// OrderFailed.js
import React from 'react';
import { Container, Paper, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function OrderFailed() {
  const navigate = useNavigate();
  return (
    <Container sx={{ py: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Payment Failed</Typography>
        <Typography sx={{ mb: 2 }}>
          Unfortunately, your transaction could not be completed.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/checkout')}>
          Try Again
        </Button>
      </Paper>
    </Container>
  );
}
